import "survey-core/survey-core.css";

import LoadingItem from "@/components/LoadingItem";
import { environment } from "@/config/env";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function SurveyPage() {
  const { accessToken } = useParams<{ accessToken: string }>();
  const navigate = useNavigate();
  useDocumentTitle("Sondaggio di Gradimento");

  const [isLoading, setIsLoading] = useState(true);
  const [completed, setCompleted] = useState(false);
  const { t } = useTranslation("survey");
  const [surveyJson, setSurveyJson] = useState<any>(null);
  useEffect(() => {
    axios
      .get<{ survey: string }>(
        `${environment.ELITE_BASE_URI}/survey/login/${accessToken}`,
      )
      .then((response) => {
        setIsLoading(false);
        setSurveyJson(JSON.parse(response.data.survey));
      })
      .catch((err) => {
        setIsLoading(false);
        switch (err.response?.status) {
          case 403:
            toast.info(t("already_submitted"), {
              position: `bottom-center`,
            });
            setCompleted(true);
            break;
          case 404:
            navigate("/not-found");
            break;
        }
      });
  }, []);
  const survey = new Model(surveyJson);
  const surveyCompleted = useCallback((survey: Model) => {
    console.info("Survey results: " + JSON.stringify(survey.data));
    axios
      .post(`${environment.ELITE_BASE_URI}/survey/submit/${accessToken}`, {
        jsonData: JSON.stringify(survey.data),
      })
      .then((res) => {
        toast.success(t("submit_success"), {
          position: `bottom-center`,
        });
      })
      .catch((err) => {});
  }, []);
  survey.onComplete.add(surveyCompleted);
  return (
    <div className="h-dvh">
      {isLoading && (
        <div className="text-center p-8">
          <LoadingItem></LoadingItem>
        </div>
      )}
      {!isLoading && !completed && <Survey model={survey} />}
      {completed && (
        <div className="text-center p-8">
          <h2 className="text-2xl font-bold">{t("already_submitted")}</h2>
        </div>
      )}
    </div>
  );
}
